module.exports = __webpack_public_path__ + "img/208.ac9a959a.png";